import {
  IProductDto,
  PRODUCT_ACTIVATION_STATUS,
  PRODUCT_TYPES,
  PRODUCT_VERIFICATION_STATUS,
} from "types/marketpleace/product.interface";
import { createMockListPage } from "./listingMocks";
import {
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  matchesAcademyIds,
  matchesOptionalNumber,
  matchesOptionalValue,
} from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID } from "./mockPlayers";
import { demoProductBanner } from "./demoImages";
import { demoApi } from "./demoLocale";

export const mockProducts: IProductDto[] = [
  {
    ProductId: "00000000-0000-0000-0000-000000000301",
    Name: "Koszulka treningowa",
    ShortDescription: "Koszulka treningowa demo",
    BannerPhotoFilePath: demoProductBanner("00000000-0000-0000-0000-000000000301"),
    Gross: 89.99,
    Amount: 42,
    Created: new Date("2026-06-01"),
    SellerId: "00000000-0000-0000-0000-000000000601",
    SellerName: "Klub piłkarski",
    SystemStatus: PRODUCT_VERIFICATION_STATUS["Zweryfikowany"],
    CurrentStatus: PRODUCT_ACTIVATION_STATUS["Aktywny"],
    CategoryId: "00000000-0000-0000-0000-000000000801",
    CategoryName: "Odzież",
    Type: PRODUCT_TYPES["Fizyczny"],
    AcademyId: DEMO_ACADEMY_ID,
    IsMainBranch: true,
  },
  {
    ProductId: "00000000-0000-0000-0000-000000000302",
    Name: "Piłka treningowa",
    ShortDescription: "Piłka treningowa demo",
    BannerPhotoFilePath: demoProductBanner("00000000-0000-0000-0000-000000000302"),
    Gross: 129,
    Amount: 15,
    Created: new Date("2026-06-10"),
    SellerId: "00000000-0000-0000-0000-000000000601",
    SellerName: "Klub piłkarski",
    SystemStatus: PRODUCT_VERIFICATION_STATUS["Zweryfikowany"],
    CurrentStatus: PRODUCT_ACTIVATION_STATUS["Aktywny"],
    CategoryId: "00000000-0000-0000-0000-000000000802",
    CategoryName: "Sprzęt",
    Type: PRODUCT_TYPES["Fizyczny"],
    AcademyId: DEMO_ACADEMY_ID,
    IsMainBranch: true,
  },
  {
    ProductId: "00000000-0000-0000-0000-000000000303",
    Name: "Pakiet wideo — technika",
    ShortDescription: "Materiały szkoleniowe online",
    BannerPhotoFilePath: demoProductBanner("00000000-0000-0000-0000-000000000303"),
    Gross: 49.99,
    Amount: 0,
    Created: new Date("2026-06-20"),
    SellerId: "00000000-0000-0000-0000-000000000601",
    SellerName: "Klub piłkarski",
    SystemStatus: PRODUCT_VERIFICATION_STATUS["Przetwarzany"],
    CurrentStatus: PRODUCT_ACTIVATION_STATUS["Nieaktywny"],
    CategoryId: "00000000-0000-0000-0000-000000000803",
    CategoryName: "Cyfrowe",
    Type: PRODUCT_TYPES["Elektroniczny"],
    AcademyId: DEMO_ACADEMY_ID,
    IsMainBranch: true,
  },
  {
    ProductId: "00000000-0000-0000-0000-000000000304",
    Name: "Bidon klubowy",
    ShortDescription: "Bidon z logo oddziału północ",
    BannerPhotoFilePath: demoProductBanner("00000000-0000-0000-0000-000000000304"),
    Gross: 29.99,
    Amount: 80,
    Created: new Date("2026-06-05"),
    SellerId: "00000000-0000-0000-0000-000000000602",
    SellerName: "Oddział Akademii",
    SystemStatus: PRODUCT_VERIFICATION_STATUS["Zweryfikowany"],
    CurrentStatus: PRODUCT_ACTIVATION_STATUS["Aktywny"],
    CategoryId: "00000000-0000-0000-0000-000000000802",
    CategoryName: "Sprzęt",
    Type: PRODUCT_TYPES["Fizyczny"],
    AcademyId: DEMO_ACADEMY_NORTH_ID,
    IsMainBranch: false,
  },
  {
    ProductId: "00000000-0000-0000-0000-000000000305",
    Name: "Czapka z daszkiem",
    ShortDescription: "Czapka oddziału południe",
    BannerPhotoFilePath: demoProductBanner("00000000-0000-0000-0000-000000000305"),
    Gross: 39.99,
    Amount: 25,
    Created: new Date("2026-06-12"),
    SellerId: "00000000-0000-0000-0000-000000000603",
    SellerName: "Oddział Akademii - Zachodni",
    SystemStatus: PRODUCT_VERIFICATION_STATUS["Zweryfikowany"],
    CurrentStatus: PRODUCT_ACTIVATION_STATUS["Aktywny"],
    CategoryId: "00000000-0000-0000-0000-000000000801",
    CategoryName: "Odzież",
    Type: PRODUCT_TYPES["Fizyczny"],
    AcademyId: DEMO_ACADEMY_SOUTH_ID,
    IsMainBranch: false,
  },
];

const productFilters = [
  (product: IProductDto, pageInfo: any) => matchesAcademyIds(product.AcademyId, pageInfo),
  (product: IProductDto, pageInfo: any) =>
    matchesOptionalValue(product.CategoryId, pageInfo.CategoryId),
  (product: IProductDto, pageInfo: any) => matchesOptionalNumber(product.Type, pageInfo.Type),
  (product: IProductDto, pageInfo: any) =>
    matchesOptionalNumber(product.CurrentStatus, pageInfo.Status),
];

export const getMockProductsPage = demoApi((pageInfo: any) =>
  createMockListPage(mockProducts, pageInfo, {
    search: (product, search) =>
      product.Name.toLowerCase().includes(search) ||
      product.CategoryName.toLowerCase().includes(search),
    filters: productFilters,
  }));
